import script from "./Apple.vue?vue&type=script&setup=true&lang=js"
export * from "./Apple.vue?vue&type=script&setup=true&lang=js"

import "./Apple.vue?vue&type=style&index=0&id=41157715&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41157715"]])

export default __exports__